import Layer from "../../../shared/Layer";
import EventTypes from "../../../shared/EventTypes";
import AbstractAction from "../AbstractAction";

export default class AddLayerAction extends AbstractAction {
    constructor(provider) {
        super(provider);

        this.layer = new Layer(provider);
        this.layer.row.action = this;
        this.layer.row.toggleEdit();
    }

    finish() {
        if (!this.layer.name) {
            this.layer.row.remove();
            super.discard();
            return;
        }
        this.layers.add(this.layer);
        this.layer.row.label.html(this.layer.name);
        this.emit(EventTypes.ADD_LAYER, this.layer);
        super.finish();
    }

    undo() {
        this.layers.remove(this.layer.id);
        this.layer.row.hide();
        this.emit(EventTypes.REMOVE_LAYER, this.layer);
    }

    redo() {
        this.layers.add(this.layer);
        this.layer.row.show();
        this.emit(EventTypes.ADD_LAYER, this.layer);
    }
}
